import * as React from "react";

import { RightIconBox, STAppBar, STProfileBox, StyledToolbar } from "./styles";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import AccountMenu from "./AccountMenu/AccountMenu";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import { RouterStore } from "mobx-react-router";
import GlobalSearchField from "./GlobalSearchField/GlobalSearchField";
import { ISearchStore } from "@src/Stores/Search/types";
import { IValuesStore } from "@src/Stores/Values/types";
import { IAuthStore } from "@src/Stores/Auth/types";
import ComponentAppFrame from "@src/Components/Common/ComponentApps/ComponentAppFrame";
import { CssBaseline } from "@material-ui/core";
import NavbarLogo from "./NavbarLogo";
import ProfileIconContainer from "./ProfileIconContainer";
import AppDrawerIcon from "./AppDrawerIcon";

interface IProps {
  onDrawerToggle: () => void;
  search?: ISearchStore;
  routing?: RouterStore;
  values?: IValuesStore;
  auth?: IAuthStore;
}

@inject("routing", "search", "values", "auth")
@observer
class TopBar extends React.Component<IProps> {
  @observable isOpened: boolean = false;
  @observable anchorEl: HTMLElement;
  @observable isOpenedApp: boolean = false;
  @observable anchorElApp: HTMLElement;

  handleClose = () => {
    this.isOpened = false;
  };

  handleOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    this.isOpened = true;
    this.anchorEl = event.currentTarget;
  };

  handleCloseApp = () => {
    this.isOpenedApp = false;
  };

  handleOpenApp = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    this.isOpenedApp = true;
    this.anchorElApp = event.currentTarget;
  };

  render() {
    return (
      <STAppBar position="fixed">
        <CssBaseline />
        <StyledToolbar disableGutters>
          <Hidden mdUp implementation="js">
            <IconButton color="inherit" aria-label="Open drawer" onClick={this.props.onDrawerToggle}>
              <MenuIcon />
            </IconButton>
          </Hidden>
          {this.props.search.searchFieldOpened ? (
            <Hidden xsDown>
              <NavbarLogo />
            </Hidden>
          ) : (
            <NavbarLogo />
          )}
          <RightIconBox>
            <GlobalSearchField />
            <IconButton
              aria-owns={this.isOpenedApp ? "menu-appbar" : undefined}
              aria-haspopup="true"
              color="inherit"
              onClick={this.handleOpenApp}
            >
              <AppDrawerIcon style={{fontSize: 18}} />
            </IconButton>
            <div id="notificationsRootElement"></div>
            <STProfileBox
              aria-owns={this.isOpened ? "menu-appbar" : undefined}
              aria-haspopup="true"
              color="inherit"
              onClick={this.handleOpen}
            >
              <ProfileIconContainer personInitials={this.props.auth.getPersonInitials(this.props.auth.user.person.fullName)}/>
              <ArrowDropDownIcon/>
            </STProfileBox>
          </RightIconBox>
          {this.isOpened && <AccountMenu anchorEl={this.anchorEl} onClose={this.handleClose} />}
          <ComponentAppFrame isOpened={this.isOpenedApp} onClose={this.handleCloseApp} anchorEl={this.anchorElApp} />
        </StyledToolbar>
      </STAppBar>
    );
  }
}

export default TopBar;
